<template>
    <modal @close="closeFromModal">
        <h5 slot="header">Détails du bon cadeau</h5>
        <div slot="body">
            <invalid-gift-voucher :gv_sale="gv_sale" :invalid_reason="invalid_reason" />
        </div>
        <div slot="footer" class="d-flex w-100 justify-content-between">
            <button class="modal-default-button btn-sm btn btn-secondary btn-circle" @click="close">Fermer</button>
        </div>
    </modal>
</template>

<script>
import InvalidGiftVoucher from "../../giftVouchers/InvalidGiftVoucher.vue";

export default {
    props: {
        gv_sale: {
            type: Object,
            required: true,
        },
        invalid_reason: {
            type: String,
            default: "Ce bon cadeau n'est pas valide",
        },
    },
    methods: {
        close() {
            this.$emit("close");
        },
        closeFromModal: function (e) {
            if (e && e.target && !e.target.classList.contains("modal-wrapper")) {
                e.stopPropagation();
            } else {
                this.close();
            }
        },
    },
    components: {
        InvalidGiftVoucher,
    },
};
</script>
